<template>
  <div
    :class="'input-bool ' + renderClasses">
    <label
      class="subtitle-1"
      v-if="renderLabel">
      {{ renderLabel }}
    </label>
    <v-radio-group
      v-model="val"
      :readonly="readonly"
      row>
      <v-radio
        label="Ja"
        :value="true" />
      <v-radio
        label="Nein"
        :value="false" />
    </v-radio-group>
  </div>
</template>

<script>
import InputMixin from './mixins/InputMixin'

export default {
  name: '',

  mixins: [
    InputMixin
  ],

  methods: {
    isValueTypeValid (value) {
      return typeof value === 'boolean'
    }
  }
}
</script>

<style lang="scss">
  .input-bool {
    .v-input--radio-group {
      margin-top: 0.2em;
      margin-bottom: 0.4em;
    }
  }
</style>
